// frontend/src/pages/index.jsx
import React from 'react';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-gray-100">
      <div className="max-w-4xl mx-auto px-4 py-8 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-800 mb-2">
            Annuity Leads For Agents - BETA
          </h1>
        </div>

        <div className="bg-white rounded-xl shadow-lg p-6 sm:p-8 space-y-6">
          <div className="text-center">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              Welcome to Our Beta Service
            </h2>
            <p className="text-gray-600">
              Thank you for visiting Annuity Leads For Agents. We're currently operating in beta mode as we work to improve our service.
            </p>
          </div>

          <div className="space-y-4">
            <h3 className="text-xl font-semibold text-gray-800">What You Should Know:</h3>
            <ul className="list-disc list-inside space-y-2 text-gray-600">
              <li>Currently, we produce approximately 1-3 leads per day</li>
              <li>There is no cost to view lead alerts</li>
              <li>You only purchase a lead (to receive full lead details) if you like what you see</li>
              <li>Our lead flow will increase significantly as we grow beyond our beta phase</li>
            </ul>
          </div>

          <div className="space-y-4">
            <h3 className="text-xl font-semibold text-gray-800">Refund Policy:</h3>
            <p className="text-gray-600">
              If you have purchased a lead from us and are not satisfied with it, you can request a refund by contacting us at:{' '}
              <a href="mailto:annuityleadsforagents@gmail.com" className="text-blue-600 hover:underline">
                annuityleadsforagents@gmail.com
              </a>
            </p>
          </div>

          <div className="space-y-4">
            <h3 className="text-xl font-semibold text-gray-800">Feedback:</h3>
            <p className="text-gray-600">
              We value your support during this beta phase. All feedback should be directed to:{' '}
              <a href="mailto:annuityleadsforagents@gmail.com" className="text-blue-600 hover:underline">
                annuityleadsforagents@gmail.com
              </a>
            </p>
          </div>

          <div className="text-center pt-4">
            <p className="text-lg font-semibold text-gray-800">THANK YOU FOR SUPPORTING US!</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;